export default __webpack_public_path__ + "static/media/icon4.61d56851.png";